import React, { ComponentType, FunctionComponent } from "react";

export type ConditionalMountProps = {
    /**
     * Příznak pro zobrazení komponenty.
     */
    mounted: boolean;
    /**
     * Komponenta, která se má vykreslit, pokud je podmínka splněna.
     */
    Component?: ComponentType;
    /**
     * Dodatečné props pro vykreslovanou komponentu.
     */
    [key: string]: any;
};

export const ConditionalMount: FunctionComponent<ConditionalMountProps> = ({ mounted, Component, ...restProps }) => (
    mounted && Component ? <Component {...restProps} /> : null
);
